/**
 * Smooche-style Interactive Conversion Engine for Supralash
 */
(function () {
  'use strict';

  function initSmoochePDP() {
    // 1. Bundle Selection Logic
    const bundleCards = document.querySelectorAll('.smooche-bundle-card');
    const hiddenVariantInput = document.getElementById('smooche-selected-variant');
    const hiddenQtyInput = document.getElementById('smooche-selected-qty');
    const mainPriceCurrent = document.querySelector('.smooche-price-current');
    const mainPriceCompare = document.querySelector('.smooche-price-compare');
    const floatingPrice = document.querySelector('.smooche-floating-bar__price');

    bundleCards.forEach(card => {
      card.addEventListener('click', function () {
        bundleCards.forEach(c => c.classList.remove('is-selected'));
        this.classList.add('is-selected');

        const variantId = this.dataset.variantId;
        const qty = this.dataset.qty || '1';
        const price = this.dataset.price;
        const compare = this.dataset.comparePrice;

        if (hiddenVariantInput && variantId) hiddenVariantInput.value = variantId;
        if (hiddenQtyInput) hiddenQtyInput.value = qty;

        if (mainPriceCurrent && price) mainPriceCurrent.textContent = price;
        if (mainPriceCompare) {
          if (compare && compare.trim() !== '') {
            mainPriceCompare.textContent = compare;
            mainPriceCompare.style.display = 'inline';
          } else {
            mainPriceCompare.style.display = 'none';
          }
        }
        if (floatingPrice && price) floatingPrice.textContent = price;
      });
    });

    // 2. Add To Cart Submission
    const atcForm = document.getElementById('smooche-atc-form');
    const atcBtn = document.getElementById('smooche-atc-submit-btn');

    if (atcForm && atcBtn) {
      atcForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const originalText = atcBtn.innerHTML;
        atcBtn.disabled = true;
        atcBtn.innerHTML = '<span class="smooche-spinner"></span> Agregando...';

        const selectedCard = document.querySelector('.smooche-bundle-card.is-selected');
        const variantId = selectedCard ? selectedCard.dataset.variantId : (hiddenVariantInput ? hiddenVariantInput.value : '');
        const qty = selectedCard ? parseInt(selectedCard.dataset.qty || '1', 10) : 1;
        const redirectCheckout = atcForm.dataset.redirectCheckout === 'true';

        if (!variantId) {
          alert('Por favor selecciona una opción válida');
          atcBtn.disabled = false;
          atcBtn.innerHTML = originalText;
          return;
        }

        const payload = {
          items: [{
            id: parseInt(variantId, 10),
            quantity: qty
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(res => res.json())
          .then(data => {
            if (data.status && data.status >= 400) {
              throw new Error(data.description || 'Error al agregar');
            }

            if (redirectCheckout) {
              window.location.href = '/checkout';
              return;
            }

            // Update cart drawer or cart count
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.openMenuDrawer === 'function') {
              // Refresh cart drawer content if theme supports it
              fetch('/cart.js')
                .then(r => r.json())
                .then(() => {
                  document.dispatchEvent(new CustomEvent('cart:refresh'));
                  cartDrawer.openMenuDrawer();
                })
                .catch(() => {
                  cartDrawer.openMenuDrawer();
                });
            } else {
              window.location.href = '/cart';
            }

            atcBtn.disabled = false;
            atcBtn.innerHTML = originalText;
          })
          .catch(err => {
            console.error('Error adding to cart:', err);
            // Fallback: standard form submit
            atcForm.submit();
          });
      });
    }

    // 3. Countdown Urgency Timer
    const countdownEl = document.getElementById('smooche-countdown-display');
    if (countdownEl) {
      const storageKey = 'supralash_smooche_countdown_end';
      let endTime = localStorage.getItem(storageKey);

      if (!endTime || parseInt(endTime, 10) <= Date.now()) {
        // Set countdown: 11 hours, 34 minutes, 23 seconds from now
        endTime = Date.now() + (11 * 3600 + 34 * 60 + 23) * 1000;
        localStorage.setItem(storageKey, endTime);
      } else {
        endTime = parseInt(endTime, 10);
      }

      function updateCountdown() {
        const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');

        countdownEl.textContent = `${hours}:${minutes}:${seconds}`;

        if (remaining <= 0) {
          // Reset for next day
          endTime = Date.now() + 12 * 3600 * 1000;
          localStorage.setItem(storageKey, endTime);
        }
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    // 3b. Urgency Progress Bar Smooth Fill Animation
    const progressFills = document.querySelectorAll('.smooche-progress-fill');
    progressFills.forEach(fill => {
      const targetPercent = fill.getAttribute('data-percentage') || '92';
      fill.style.width = '0%';
      setTimeout(() => {
        fill.style.width = targetPercent.endsWith('%') ? targetPercent : (targetPercent + '%');
      }, 250);
    });

    // 4. Accordion FAQ logic
    const faqTriggers = document.querySelectorAll('.smooche-faq-trigger');
    faqTriggers.forEach(btn => {
      btn.addEventListener('click', function () {
        const parent = this.closest('.smooche-faq-item');
        const isOpen = parent.classList.contains('is-open');

        // Optional: close other items in the same list
        const parentList = parent.closest('.smooche-faq-list');
        if (parentList) {
          parentList.querySelectorAll('.smooche-faq-item').forEach(it => {
            if (it !== parent) it.classList.remove('is-open');
          });
        }

        parent.classList.toggle('is-open', !isOpen);
      });
    });

    // 5. Gallery Thumbnail Switcher & Arrows
    const mainImg = document.querySelector('.smooche-gallery__main-img');
    const thumbs = document.querySelectorAll('.smooche-gallery__thumb');
    const prevArrow = document.querySelector('.smooche-gallery__arrow--prev');
    const nextArrow = document.querySelector('.smooche-gallery__arrow--next');

    let currentThumbIndex = 0;

    function setActiveThumb(index) {
      if (!thumbs.length) return;
      currentThumbIndex = (index + thumbs.length) % thumbs.length;
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === currentThumbIndex));

      const activeThumb = thumbs[currentThumbIndex];
      const targetSrc = activeThumb.dataset.fullSrc || activeThumb.querySelector('img')?.src;
      if (mainImg && targetSrc) {
        mainImg.style.opacity = '0.4';
        setTimeout(() => {
          mainImg.src = targetSrc;
          mainImg.style.opacity = '1';
        }, 120);
      }
    }

    thumbs.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => setActiveThumb(idx));
    });

    if (prevArrow) {
      prevArrow.addEventListener('click', () => setActiveThumb(currentThumbIndex - 1));
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', () => setActiveThumb(currentThumbIndex + 1));
    }

    // 6. UGC Video Modal Player
    const ugcCards = document.querySelectorAll('.smooche-ugc-card');
    const videoModal = document.getElementById('smooche-video-modal');
    const modalVideo = document.getElementById('smooche-modal-video');
    const modalClose = document.getElementById('smooche-modal-close');

    if (videoModal && modalVideo) {
      ugcCards.forEach(card => {
        card.addEventListener('click', function () {
          const videoSrc = this.dataset.videoUrl;
          if (videoSrc) {
            modalVideo.src = videoSrc;
            videoModal.classList.add('is-active');
            modalVideo.play().catch(() => {});
          }
        });
      });

      function closeModal() {
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalVideo.src = '';
        videoModal.classList.remove('is-active');
      }

      if (modalClose) modalClose.addEventListener('click', closeModal);
      videoModal.addEventListener('click', function (e) {
        if (e.target === videoModal) closeModal();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && videoModal.classList.contains('is-active')) {
          closeModal();
        }
      });
    }

    // 7. Interactive Before / After Slider
    const baContainers = document.querySelectorAll('.smooche-ba-slider-container');
    baContainers.forEach(container => {
      const beforeImg = container.querySelector('.smooche-ba-img--before');
      const handle = container.querySelector('.smooche-ba-handle');
      if (!beforeImg || !handle) return;

      let isDragging = false;

      function updateSlider(x) {
        const rect = container.getBoundingClientRect();
        let posX = x - rect.left;
        posX = Math.max(0, Math.min(posX, rect.width));
        const percent = (posX / rect.width) * 100;

        beforeImg.style.width = percent + '%';
        handle.style.left = percent + '%';
      }

      function onMove(e) {
        if (!isDragging) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        updateSlider(clientX);
      }

      container.addEventListener('mousedown', e => {
        isDragging = true;
        updateSlider(e.clientX);
      });
      container.addEventListener('touchstart', e => {
        isDragging = true;
        updateSlider(e.touches[0].clientX);
      }, { passive: true });

      window.addEventListener('mouseup', () => { isDragging = false; });
      window.addEventListener('touchend', () => { isDragging = false; });
      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
    });

    // 8. Bottom Floating Buy Bar on Scroll
    const floatingBar = document.querySelector('.smooche-floating-bar');
    if (floatingBar && atcBtn) {
      window.addEventListener('scroll', function () {
        const rect = atcBtn.getBoundingClientRect();
        if (rect.bottom < 0) {
          floatingBar.classList.add('is-visible');
        } else {
          floatingBar.classList.remove('is-visible');
        }
      }, { passive: true });

      const floatingBtn = floatingBar.querySelector('.smooche-floating-bar__btn');
      if (floatingBtn) {
        floatingBtn.addEventListener('click', () => {
          atcBtn.click();
        });
      }
    }
  }

  // Initialize on DOMContentLoaded and on Shopify Section Re-renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoochePDP);
  } else {
    initSmoochePDP();
  }

  document.addEventListener('shopify:section:load', initSmoochePDP);
})();
